export default {
  weatherReport: {
    title: "Weather",
    labels: {
      forecastUnavailable: "Forecast Unavailable",
      unavailableDescription: "Weather forecast unavailable for this game.",
      unavailableValue: "N/A",
    },
    empty: {
      title: "No weather reports available",
    },
  },
};
